var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1257 3.52308L6.53636 8.11244C5.62878 9.02011 5.01073 10.1765 4.76037 11.4354C4.51001 12.6944 4.63857 13.9992 5.1298 15.1851C5.62103 16.371 6.45287 17.3845 7.52013 18.0976C8.58739 18.8107 9.84214 19.1913 11.1257 19.1913C12.4093 19.1913 13.664 18.8107 14.7313 18.0976C15.7986 17.3845 16.6304 16.371 17.1216 15.1851C17.6129 13.9992 17.7414 12.6944 17.4911 11.4354C17.2407 10.1765 16.6226 9.02011 15.7151 8.11244L11.1257 3.52308ZM11.1257 0.901123L17.0261 6.80146C18.193 7.96843 18.9877 9.45524 19.3097 11.0739C19.6316 12.6925 19.4664 14.3703 18.8348 15.895C18.2033 17.4197 17.1337 18.7229 15.7615 19.6398C14.3893 20.5566 12.7761 21.046 11.1257 21.046C9.47537 21.046 7.8621 20.5566 6.48989 19.6398C5.11768 18.7229 4.04817 17.4197 3.41661 15.895C2.78505 14.3703 2.6198 12.6925 2.94175 11.0739C3.26371 9.45524 4.05842 7.96843 5.22538 6.80146L11.1257 0.901123V0.901123Z",
    fill: "#838BAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2514,
    height: 22.2514,
    fill: "white",
    transform: "translate(0 0.64856)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHum);
export default __webpack_public_path__ + "static/media/hum.72b92500b580f0201fb08a3ec492b3f2.svg";
export { ForwardRef as ReactComponent };